import React from 'react';

import { useIntl } from 'react-intl-next';

import { cssMap } from '@atlaskit/css';
import Heading from '@atlaskit/heading';
import Link from '@atlaskit/link';
import { Box, Grid, Stack, Text } from '@atlaskit/primitives/compiled';
import { TabPanel } from '@atlaskit/tabs';
import { token } from '@atlaskit/tokens';

import { messages } from '../messages';

import { Panel } from './panel-wrapper';

const styles = cssMap({
	singleColumnGrid: {
		gridTemplateColumns: '1fr',
		borderTopWidth: token('border.width'),
		borderTopStyle: 'solid',
		borderTopColor: token('color.border'),
		borderLeftWidth: token('border.width'),
		borderLeftStyle: 'solid',
		borderLeftColor: token('color.border'),
	},
	gridHeader: {
		backgroundColor: token('color.background.neutral'),
		paddingTop: token('space.100'),
		paddingBottom: token('space.100'),
		paddingLeft: token('space.150'),
		paddingRight: token('space.150'),
		borderBottomWidth: token('border.width'),
		borderBottomStyle: 'solid',
		borderBottomColor: token('color.border'),
		borderRightWidth: token('border.width'),
		borderRightStyle: 'solid',
		borderRightColor: token('color.border'),
	},
	gridUrlCell: {
		paddingTop: token('space.100'),
		paddingBottom: token('space.100'),
		paddingLeft: token('space.150'),
		paddingRight: token('space.150'),
		borderBottomWidth: token('border.width'),
		borderBottomStyle: 'solid',
		borderBottomColor: token('color.border'),
		borderRightWidth: token('border.width'),
		borderRightStyle: 'solid',
		borderRightColor: token('color.border'),
		wordBreak: 'break-all',
	},
});

type RawSearchResultsPanelProps = {
	searchResults: string[];
};

export const RawSearchResultsPanel = ({ searchResults }: RawSearchResultsPanelProps) => {
	const { formatMessage } = useIntl();

	return (
		<TabPanel>
			<Panel testId="sain-online-debugger-raw-search-results-panel">
				{searchResults.length > 0 ? (
					<Stack space="space.050">
						<Heading size="xsmall">
							{formatMessage(messages.ai_debugger_modal_raw_search_results_heading, {
								count: searchResults.length,
							})}
						</Heading>
						<Grid xcss={styles.singleColumnGrid}>
							<Box xcss={styles.gridHeader}>
								<Text weight="semibold">
									{formatMessage(messages.ai_debugger_modal_table_url_header)}
								</Text>
							</Box>
							{searchResults.map((url, index) => (
								<Box key={`${url}-${index}`} xcss={styles.gridUrlCell}>
									<Link href={url} target="_blank">
										{url}
									</Link>
								</Box>
							))}
						</Grid>
					</Stack>
				) : (
					<Text>{formatMessage(messages.ai_debugger_modal_no_raw_search_results)}</Text>
				)}
			</Panel>
		</TabPanel>
	);
};
